
import {defineComponent, PropType} from "vue";
import BrandImageComponent from "@/components/recorder/partials/BrandImageComponent.vue";
import FullHeaderComponent from "@/components/recorder/partials/FullHeaderComponent.vue";
import FooterComponent from "@/components/recorder/partials/FooterComponent.vue";
import {Campaign} from "@/models/campaign";
import BackgroundImageMixin from "@/components/recorder/BackgroundImageMixin.vue";
import ReplayButtonComponent from "@/components/recorder/partials/ReplayButtonComponent.vue";
import VideoMixin from "@/components/recorder/VideoMixin.vue";
import {mapActions} from "pinia";
import {useAnalyticsStore} from "@/store/analytics.store";

export default defineComponent( {
    name: "PromptComponent",
    components: {ReplayButtonComponent, FooterComponent, FullHeaderComponent, BrandImageComponent},
    mixins: [BackgroundImageMixin, VideoMixin],
    props: {
        campaign: {
            type: Object as PropType<Campaign>,
            required: true,
        },
        recordingDeniedReason: String,
        isRecordingPossible: Boolean,
    },
    methods: {
        ...mapActions(useAnalyticsStore, ['trackEvent']),

        // we want to prevent the default behaviour and stop propagation
        // otherwise we emit two recordingRequested events
        // which leads to creating two media recording streams
        emitRecordingRequested(event: TouchEvent | MouseEvent): void {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('recordingRequested');
        },
        replayVideo() {
            this.trackEvent('replayVideoPreRollClicked', {
                ...this.$analytics.campaignParams(this.campaign),
            });
            this.goBack();
        },
        goBack() {
            this.$emit('goBack');
        },
    },
    computed: {
        promptText(): string {
            return this.campaign.promptText;
        },
        promptBubbleLabel(): string {
            if (this.campaign.promptSublineText) {
                return this.campaign.promptSublineText;
            }

            return this.$t('creation.promptBubbleLabel', { name: this.campaign.profile.name || this.campaign.profile.url });
        },
        recordButtonLabel(): string {
            if (this.campaign.recordButtonLabel) {
                return this.campaign.recordButtonLabel;
            }
            return this.$t('creation.startRecordingButtonLabel');
        },
    }
});
